import { getServiceInstance } from "./base.service";
import { getToken } from "libraries/amplify.library";
const BASE_URL = (process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');

export const fetchFumigationCompanyDetailsService = async () => {
    try {
        const authToken = getToken()

        const response = await getServiceInstance().get(`${BASE_URL}/fumigator-details`, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching fumigation companies details:", error);
        throw error;

    }
}